// extracted by mini-css-extract-plugin
export default {"tag":"ARMhokT","tag--default":"IauYZWj","tag--disabled":"wKxkkFT","tag--lime":"dnrepQK","tag__button":"eJOpSfE","tag__icon":"T9MaZqL"};